import React from "react";
import IconBase from "./IconBase";

const SpeechHelpIcon = props => {
    return (
        <IconBase {...props}>
            <path d="M6,14h8v-2H6V14z M6,11h12V9H6V11z M6,8h12V6H6V8z M2,22V4c0-0.5,0.2-1,0.6-1.4S3.5,2,4,2h16c0.6,0,1,0.2,1.4,0.6
	S22,3.4,22,4v12c0,0.5-0.2,1-0.6,1.4S20.6,18,20,18H6L2,22z M4,16V4V16z"/>
        </IconBase>
    )
}

export default SpeechHelpIcon;